module.exports = __webpack_public_path__ + "static/media/Brazil - BR.eda960cb.png";